import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { of } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ELearningService } from '../e-learning.service';
import { ModalAssignmentComponent } from './modal-assignment/modal-assignment.component';
import { ModalCertificateComponent } from './modal-certificate/modal-certificate.component';
import { ModalQuizComponent } from './modal-quiz/modal-quiz.component';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { DOC_ORIENTATION, NgxImageCompressService, } from 'ngx-image-compress';
import { AuthService } from 'src/app/core/services/auth/auth.service';

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class CourseComponent implements OnInit {

  @ViewChild('chatroom') private chatroom: ElementRef;

  screenWidth: number = window.innerWidth;
  reviewForm: FormGroup;
  chatForm: FormGroup;
  subChatForm: FormGroup;
  privateChatForm: FormGroup;
  courseDetail;
  topicComplete;

  isLoading: boolean;

  // review
  reviews;
  listReviews = [];
  allReview = [];
  isReviewMore: boolean;
  chunkReviewIndex: number = 1;

  // chat
  listChat = [];
  allChat = [];
  isChatMore: boolean;
  chunkChatIndex: number = 1;

  countList: number = 20;
  urlVdo: string; // use for change url video
  urlVdoRender;
  progress: number;
  panelOpenState: boolean = false;
  panelOpenReply: number;

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    margin: 15,
    autoplay: false,
    dots: true,
    navSpeed: 700,
    nav: false,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      760: {
        items: 3
      },
      1000: {
        items: 4
      }
    }
  }

  privateMessage = [];
  privateChatImg = [];
  privateChatRemoveFile = [];

  fileList: NzUploadFile[] = [];
  previewImage: string | undefined = '';
  previewVisible = false;

  //  for compress image
  localUrl: any;
  localCompressedURl: any;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  incomingMessage: boolean = false;
  token: string = '';

  courseDes: any;

  successRequest = ({ file, onSuccess, onError }) => {
    const fileType = this.gbFunction.getTypeFile(file);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv' || fileType === 'jpg' || fileType === 'png' || fileType === 'jpeg') {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    } else {
      setTimeout(() => {
        onError('error');
      }, 0);
    }
  };

  constructor(
    public matDialog: MatDialog,
    private elearningService: ELearningService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private gobalFunctionService: GobalFunctionService,
    private gbFunction: GobalFunctionService,
    private imageCompress: NgxImageCompressService,
    private authService: AuthService,
  ) {
    this.reviewForm = this.fb.group({
      rating: ['', Validators.required],
      review: ['', Validators.required]
    })
    this.chatForm = this.fb.group({
      chat: ['', Validators.required]
    })
    this.subChatForm = this.fb.group({
      chat: ['', Validators.required]
    })
    this.privateChatForm = this.fb.group({
      message: ['', Validators.required],
      messageType: ['text', Validators.required],
      userType: ['user', Validators.required],
      imageName: [''],
      file: ['']
    })

    this.token = this.authService.getToken();
  }

  ngOnInit(): void {
    this.route.params.pipe(
      first(),
      switchMap(params => {
        return this.elearningService.getDetailCourseById(params['courseId']);
      }),
      switchMap(course => {
        this.courseDetail = course.result[0];
        this.topicComplete = course.result[0];

        this.urlVdoRender = this.sanitizer.bypassSecurityTrustResourceUrl(this.courseDetail.COURSE_VDO_EXAMPLE);
        // console.log(this.courseDetail);
        this.courseDes = this.sanitizer.bypassSecurityTrustHtml(this.courseDetail.COURSE_DESCRIPTION);
        this.gobalFunctionService.setSEO(this.courseDetail.COURSE_NAME, 'website', this.courseDetail.COURSE_DESCRIPTION);
        return this.elearningService.getChatByCourseId(this.courseDetail.COURSE_ID)
      }),
      switchMap(chat => {
        this.allChat = Array.from(chat.result.respon);
        // console.table(this.allChat);

        this.readChatMore();

        return this.elearningService.getAllReviewByCourseId(this.courseDetail.COURSE_ID)
      }),
      switchMap(reviews => {
        // // console.log(reviews.result);
        this.reviews = reviews.result;
        this.allReview = Array.from(reviews.result.REVIEW_LIST);
        this.readReviewMore();

        if (this.token) {
          this.getPrivateChat();
        }

        if (this.courseDetail.IS_PROMISE) {
          return this.getProgress();
        } else {
          return of(null);
        }
      }),
      catchError(err => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe()

    // this.scrollToBottom();
  }

  getPrivateChat() {
    this.elearningService.getPrivateChat(this.courseDetail.COURSE_ID).pipe(
      map(privateChat => {
        this.privateMessage = privateChat.result
        // console.log(this.privateMessage)
        if (this.privateMessage.length > 0) {

          if (this.privateMessage[this.privateMessage.length - 1].USER_TYPE === 'admin') {
            this.incomingMessage = true;
          } else {
            this.incomingMessage = false;
          }
        }
      })
    ).subscribe();
  }

  getTopic(topicId, type, lessonId, name) {
    const body = {
      TOPIC_ID: topicId,
      TOPIC_TYPE: type
    }

    if (type === 'Video') {
      this.elearningService.getDetailTopicCourseVideo(body).pipe(
        switchMap(res => {
          let url = `${res.result[0].VIDEO_LINK}?h=${res.result[0].HASH_KEY}&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`;
          this.urlVdo = url;
          this.urlVdoRender = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          const body2 = {
            TOPIC_ID: topicId,
            TOPIC_TYPE: type,
            COURSE_ID: this.courseDetail.COURSE_ID,
            LESSON_ID: lessonId
          }

          this.hideUrlVdo(url);
          return this.elearningService.updateStatusLessonTopic(body2);
        }),
        switchMap(() => {
     
          return this.getProgress();
        }),
        catchError(err => {
          if (err.error === 'token not found')
            this.gobalFunctionService.removeToken();
          else {
            alert(err.error);
            return of(null);
          }
        })
      ).subscribe()
     
    } else if (type === 'Quiz') {
      // // console.log(type);
      const dialogConfig = new MatDialogConfig();

      this.elearningService.getDetailTopicCourseQuiz(body).subscribe(res => {
        // // console.log(res.result)
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modalQuiz';
        dialogConfig.width = '450px';
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
          actionBtnText: 'ส่งคำตอบ',
          courseId: this.courseDetail.COURSE_ID,
          lessonId: lessonId,
          type: type,
          data: res.result
        }
        const modal = this.matDialog.open(ModalQuizComponent, dialogConfig);
        modal.afterClosed().pipe(
          switchMap(point => {
            // // console.log(point);

            if (point.status) {
              // // console.log(point)

              if (point.value.QUIZ_PASS) {
                const dialogConfig2 = new MatDialogConfig();
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalQuizPoint';
                dialogConfig2.width = '450px';
                dialogConfig2.autoFocus = false;
                dialogConfig2.data = {
                  cancleBtnText: 'ปิด',
                  title: 'ผลการทดสอบ',
                  description: `ยินดีด้วย คุณสอบผ่านการทดสอบ ด้วยคะแนน ${point.value.YOURPOINT}/${point.value.POINT_MAX} `
                }
                const modal2 = this.matDialog.open(ModalComponent, dialogConfig2);

                return modal2.afterClosed().pipe(
                  switchMap(() => {
                    return this.getProgress()
                  })
                )
              } else {
                const dialogConfig2 = new MatDialogConfig();
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalQuizPoint';
                dialogConfig2.width = '450px';
                dialogConfig2.autoFocus = false;
                dialogConfig2.data = {
                  cancleBtnText: 'ปิด',
                  title: 'ผลการทดสอบ',
                  description: `<span class="text-danger" style="text-decoration: underline;">คุณสอบไม่ผ่าน</span> ด้วยคะแนน ${point.value.YOURPOINT}/${point.value.POINT_MAX}
                  <br /> คุณสามารถทดสอบได้อีกครั้งในวันที่ ${point.value.DATE_QUIZ_AGAIN}`
                }
                const modal2 = this.matDialog.open(ModalComponent, dialogConfig2);

                return modal2.afterClosed()
              }
            } else {
              if (point.value.length > 0) {
                const dialogConfig2 = new MatDialogConfig();
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalQuizPoint';
                dialogConfig2.width = '450px';
                dialogConfig2.autoFocus = false;
                dialogConfig2.data = {
                  cancleBtnText: 'ปิด',
                  title: 'ผลการทดสอบ',
                  description: `${point.value}`
                }
                const modal2 = this.matDialog.open(ModalComponent, dialogConfig2);

                return modal2.afterClosed()
              } else {
                return of(null);
              }
            }
          })
        ).subscribe();
      }, err => {
        if (err.error.message === 'token not found')
          this.gobalFunctionService.removeToken();
        else {
          alert(err.error.message);
        }
      })
    } else if (type === 'Assignment') {
      // // console.log(type);

      const dialogConfig = new MatDialogConfig();

      this.elearningService.getDetailTopicCourseAssignment(body).pipe(
        switchMap(res => {
          // // console.log(res.result)
          dialogConfig.disableClose = true;
          dialogConfig.id = 'modalAssignment';
          dialogConfig.width = '700px';
          dialogConfig.autoFocus = false;
          dialogConfig.data = {
            // actionBtnText: 'ส่งคำตอบ',
            courseId: this.courseDetail.COURSE_ID,
            topicId: topicId,
            lessonId: lessonId,
            type: type,
            title: name,
            data: res.result
          }
          const modal = this.matDialog.open(ModalAssignmentComponent, dialogConfig);
          return modal.afterClosed().pipe(
            switchMap(res => {
              // // console.log(res);

              if (!res.status) {
                return this.getProgress();
              }
            })
          )
        }),
        catchError(err => {
          if (err.error.message === 'token not found')
            this.gobalFunctionService.removeToken();
          else {
            alert(err.error.message);
            return of(null);
          }
        })
      ).subscribe()
    } else if (type === 'Measure') {
      // // console.log(type);

      this.elearningService.getDetailTopicCourseMeasure(body).pipe(
        switchMap(res => {
          // // console.log(res);
          window.open(`measure/${res.result.LINK}`, '_blank');

          const body2 = {
            TOPIC_ID: topicId,
            TOPIC_TYPE: type,
            COURSE_ID: this.courseDetail.COURSE_ID,
            LESSON_ID: lessonId
          }
          // // console.log(body2);

          return this.elearningService.updateStatusLessonTopic(body2).pipe(
            switchMap(() => {
              return this.getProgress();
            })
          );
        }),
        catchError(err => {
          if (err.error.message === 'token not found')
            this.gobalFunctionService.removeToken();
          else {
            alert(err.error.message);
            return of(null);
          }
        })
      ).subscribe()
    }
  }

  hideUrlVdo(url:string) {
    let blob = URL['createObjectURL'](new Blob([''], { type: 'text/html' }));
    let iframe = document['getElementById']('vdoFrame');

    iframe['setAttribute']('src', blob);
    setTimeout(() => {
      iframe['contentWindow']['document'].write('<script type="text/javascript">location.href = "' + url+ '";\x3c/script>');
    }, 300);
  }

  confirmReview(r) {
    const body = {
      COURSE_ID: this.courseDetail.COURSE_ID,
      REVIEW_MESSAGE: r.review,
      REVIEW_POINT: r.rating
    }
    this.isLoading = true;
    // // console.log(body);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '350px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'สำเร็จ',
      description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ขอบคุณสำหรับการแสดงความคิดเห็น`,
      cancleBtnText: 'ยืนยัน',
      customStyle: 'background-color: #58595B;'
    }

    this.elearningService.createReviewByCourseId(body).pipe(
      switchMap(res => {
        // // console.log(res);
        return this.elearningService.getAllReviewByCourseId(this.courseDetail.COURSE_ID)
      }),
      switchMap(reviews => {
        this.reviews = reviews.result;
        this.allReview = Array.from(reviews.result.REVIEW_LIST);
        this.readReviewMore();
        this.isLoading = false;
        const modal = this.matDialog.open(ModalComponent, dialogConfig);
        return modal.afterClosed()
      }),
      catchError((err) => {
        if (err.error.message === 'token not found')
          this.gobalFunctionService.removeToken();
        else {
          alert(err.error.message);
          this.isLoading = false;
          return of(false);
        }
      })
    ).subscribe()
  }

  getCertificate() {
    // // console.log(this.courseDetail.COURSE_ID);
    this.isLoading = true;

    this.elearningService.getCertificateByCourse(this.courseDetail.COURSE_ID).pipe(
      switchMap(res => {
        // // console.log(res);
        if (res.success) {
          this.isLoading = false;
          // // console.log(res.result);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.id = 'modalConfirm';
          dialogConfig.width = '400px';
          dialogConfig.autoFocus = false;
          dialogConfig.data = {
            title: 'ใบ Certificate',
            COURSE_ID: this.courseDetail.COURSE_ID,
            COURSE_NAME: res.result.COURSE_NAME,
            USERNAME: res.result.USERNAME,
            LEARN_FROM: res.result.LEARN_FROM,
            LEARN_TO: res.result.LEARN_TO,
          }

          this.isLoading = true;
          const modal = this.matDialog.open(ModalCertificateComponent, dialogConfig);

          return modal.afterClosed().pipe(
            switchMap(r => {
              if (r.status) {
                return this.elearningService.createCertificateByCourse(r.body).pipe(
                  switchMap(res => {
                    this.isLoading = false;
                    dialogConfig.disableClose = true;
                    dialogConfig.id = 'modalConfirm';
                    dialogConfig.width = '450px';
                    dialogConfig.data = {
                      title: 'ใบ certificate',
                      description: `<img src="../../../assets/congratulation.png" width="80px;" class="img-center">ยินดีด้วยคุณได้รับใบ certificate แล้ว
                      ระบบจะส่งใบ certificate ไปยัง E-mail ของคุณ
                      <p class="text-danger">ขอความกรุณาผู้เรียนโปรดเก็บบันทึกไฟล์ดังกล่าวไว้เนื่องจากระบบจะออกวุฒิบัตรได้เพียงครั้งเดียวเท่านั้น</p>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B'
                    }

                    const closemodal = this.matDialog.open(ModalComponent, dialogConfig);
                    return closemodal.afterClosed().pipe(
                      map(c => {
                        if (!c) {
                          this.isLoading = false;
                          this.router.navigate(['/']);
                        }
                      })
                    )
                  })
                )
              } else {
                this.isLoading = false;
                return of(null);
              }
            })
          )
        }
      }),
      catchError((err) => {
        if (err.error.message === 'token not found')
          this.gobalFunctionService.removeToken();
        else {
          alert(err.error.message);
          this.isLoading = false;
          return of(false);
        }
      })
    ).subscribe();

  }

  getSkillTreeByCourse(courseId) {
    window.open('/skill-tree?course_id=' + courseId, '_blank');
  }

  getDoc(doc) {
    window.open(doc, '_blank');
  }

  confirmChat(c, type, cid?) {
    const body = {
      COURSE_ID: this.courseDetail.COURSE_ID,
      CHAT_MESSAGE: c,
      CHAT_TYPE: type,
      CHAT_MAIN_ID: cid ? cid : ''
    }
    this.isLoading = true;

    this.elearningService.createChatByCourseId(body).pipe(
      switchMap(() => {
        return this.elearningService.getChatByCourseId(this.courseDetail.COURSE_ID).pipe(
          map(chat => {
            this.allChat = Array.from(chat.result.respon);
            this.readChatMore();
            this.chatForm.reset();
            this.subChatForm.reset();
            this.isLoading = false;
          })
        )
      }),
      catchError((err) => {
        if (err.error.message === 'token not found')
          this.gobalFunctionService.removeToken();
        else {

          alert(err.error.message);
          this.isLoading = false;
          return of(false);
        }
      })
    ).subscribe()
  }

  changeFavorite(id) {
    const body = {
      COURSE_ID: id,
      FAVORITE: !this.courseDetail.IS_FAVORITE
    }
    this.elearningService.favoriteCourse(body).subscribe(res => {
      // // console.log(res);
      this.courseDetail.IS_FAVORITE = !this.courseDetail.IS_FAVORITE;
    }, err => {
      if (err.error.message === 'token not found')
        this.gobalFunctionService.removeToken();
      else
        alert(err.error.message);
    })
  }

  getProgress() {
    return this.elearningService.getDetailCourseById(this.courseDetail.COURSE_ID).pipe(
      switchMap(course => {
        this.topicComplete = course.result[0];
        return this.elearningService.getProgressCourseId(this.courseDetail.COURSE_ID)
      }),
      map(progress => {
        // // console.log(progress);
        this.progress = progress.result.PROGRESS
        if (progress.result.FIRST_COMPLETE) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.id = 'modalComplateCourse';
          dialogConfig.width = '450px';
          dialogConfig.autoFocus = false;

          if (progress.result.COURSE_COIN_REWARD > 0) {
            dialogConfig.data = {
              cancleBtnText: 'ปิด',
              title: `ยินดีด้วยคุณเรียนจบคอร์สแล้ว`,
              description: `<img src="../../../assets/coin.png" width="80px;" class="img-center">คุณได้รับได้ ${progress.result.COURSE_COIN_REWARD} Coin`
            }

          } else {
            dialogConfig.data = {
              cancleBtnText: 'ปิด',
              title: `ยินดีด้วยคุณเรียนจบคอร์สแล้ว`,
              description: `<img src="../../../assets/congratulation.png" width="80px;" class="img-center"> ยินดีด้วยคุณเรียนจบคอร์สแล้ว`
            }
          }
          const modal = this.matDialog.open(ModalComponent, dialogConfig);
          return modal.afterClosed()
        }
      })
    )
  }

  viewCourse(courseId) {
    this.router.navigate(['e-learning/' + courseId])
      .then(() => {
        window.location.reload();
      });
  }

  replyById(i) {
    if (i === this.panelOpenReply) {
      this.panelOpenReply = null;
    } else {
      this.panelOpenReply = i;
    }
  }

  readReviewMore() {
    this.listReviews = this.allReview.slice(0, this.chunkReviewIndex * this.countList);

    if (this.allReview.length <= this.chunkReviewIndex * this.countList) {
      this.isReviewMore = false;
    } else {
      this.isReviewMore = true;
    }
    this.chunkReviewIndex++;
  }

  readChatMore() {
    this.listChat = this.allChat.slice(0, this.chunkChatIndex * this.countList);

    if (this.allChat.length <= this.chunkChatIndex * this.countList) {
      this.isChatMore = false;
    } else {
      this.isChatMore = true;
    }
    this.chunkChatIndex++;
  }

  onResize(event) {
    this.screenWidth = event.target.innerWidth;
  }

  buyCourse() {
    let id = this.courseDetail.COURSE_ID
    let type = 'course';
    // // console.log(id);
    // // console.log(type);

    const queryParams: Params = { id: id, type: type };
    this.router.navigate(
      ['/payment'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
  }

  openLogin() {
    this.router.navigate(['login'], { state: { redirect: this.router.url } })
  }

  sendImageStatus: boolean;
  sendTextStatus: boolean;

  getStatusSending(e) {
    if (e.trim() === '') {
      this.sendTextStatus = false;
    } else {
      this.sendTextStatus = true;
    }

  }

  handleChange(e, chatForm) {
    // console.log(e);
    let fileName: any;
    let fileList = [...e.fileList];
    const fileType = this.gbFunction.getTypeFile(e.file);
    fileName = e.file.originFileObj.name;
    let newObj


    switch (e.file.status) {
      case 'done': {

        if (fileType === 'jpg' || fileType === 'png' || fileType === 'jpeg') {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            // // console.log(event);

            // image before compress
            this.imgResultBeforeCompress = reader.result as string;
            this.localUrl = event.target.result;
            // newFile = this.compressFile(this.localUrl, fileName, fileType);
            this.compressFile(this.localUrl, fileName, fileType).then(data => {
              // console.log(data);
              // // console.log(data.name);
              newObj = data;
              newObj['uid'] = e.file.originFileObj.uid

              // console.log(newObj);
              // // console.log(e.fileList.indexOf(data.name));
              var index = e.fileList.findIndex(
                (file) => file.name === newObj.name
              )
              // console.log(index);
              if (index !== -1) {
                e.fileList[index].originFileObj = newObj;
                e.fileList[index].lastModified = newObj.lastModified;
                e.fileList[index].lastModifiedDate = newObj.lastModifiedDate;
                e.fileList[index].size = newObj.size;
              }

              if (fileList.length > 5) {
                let removeExcess = [...fileList].splice(0, fileList.length - 5);

                e.fileList = fileList.slice(-5);

                for (let i = 0; i < removeExcess.length; i++) {
                  if (removeExcess[i].uid) {
                    this.privateChatRemoveFile.push(removeExcess[i].uid)
                  }
                }
              }

              fileList = fileList.slice(-5);
              fileList = fileList.map(file => {
                if (file.response) {
                  file.url = file.response.url;
                }
                return file;
              });

              chatForm.patchValue({
                file: e
              });
              chatForm.get('file').updateValueAndValidity();

              this.fileList = fileList;
              // console.log(this.privateChatForm);
            })

          }
          reader.readAsDataURL(e.file.originFileObj);

        } else if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
          if (fileList.length > 5) {
            let removeExcess = [...fileList].splice(0, fileList.length - 5);

            e.fileList = fileList.slice(-5);

            for (let i = 0; i < removeExcess.length; i++) {
              if (removeExcess[i].uid) {
                this.privateChatRemoveFile.push(removeExcess[i].uid)
              }
            }
          }

          fileList = fileList.slice(-5);
          fileList = fileList.map(file => {
            if (file.response) {
              file.url = file.response.url;
            }
            return file;
          });

          chatForm.patchValue({
            file: e
          });
          chatForm.get('file').updateValueAndValidity();

          this.fileList = fileList;
        }
        this.sendImageStatus = true;
        break;
      }
      case 'removed': {
        // console.log(e);
        if (typeof (e.file.uid) === 'number') {
          this.privateChatRemoveFile.push(e.file.uid)
        } else {
          chatForm.patchValue({
            file: e
          });
          chatForm.get('file').updateValueAndValidity();
        }
        break;
      }
    }

    if (e.fileList.length === 0) {
      this.sendImageStatus = false;
    }

    // console.log(this.privateChatForm);

  }

  compressFile(image, fileName, fileType) {
    // // console.log(image);
    var type = fileType === 'jpg' ? 'image/jpeg' : fileType === ' jpeg' ? 'image/jpeg' : 'image/png';
    var orientation = -1;
    return this.imageCompress.compressFile(image, orientation, 50, 50).then(
      result => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        // create file from byte
        const imageName = fileName;
        // call method that creates a blob from dataUri
        const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
        const imageFile = new File([imageBlob], imageName, { type: type });

        return imageFile
      }
    );
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  sendPrivateChat(form) {
    // console.log(form);
    let fileType
    this.isLoading = true;

    if (form.value.message.trim() === '') {
      // console.log(form);
      form.controls['message'].setValue('');
      form.controls['messageType'].setValue('text');
      form.controls['userType'].setValue('user');
      form.controls['imageName'].setValue('');

    } else {

      this.privateChatImg.push(
        {
          MESSAGE_TYPE: form.value.messageType,
          USER_TYPE: form.value.userType,
          MESSAGE: form.value.message,
          IMAGE_NAME: form.value.imageName
        }
      )
    }

    if (form.value.file !== '') {
      form.value.file.fileList.forEach(e => {
        // console.log(e.name);
        switch (e.type) {
          case 'application/pdf':
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          case 'application/vnd.ms-excelapplication/msword':
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          case 'text/csv':
          case 'application/vnd.ms-excel': {
            fileType = 'file';
          } break;

          case 'image/jpeg':
          case 'image/png': {
            fileType = 'image';
          }
        }
        this.privateChatImg.push(
          {
            MESSAGE_TYPE: fileType,
            USER_TYPE: "user",
            MESSAGE: "",
            IMAGE_NAME: e.name
          }
        )
      });
    }

    this.elearningService.postPrivateChat(form.value, this.privateChatImg, this.courseDetail.COURSE_ID).pipe(
      switchMap(res => {
        if (res.success) {
          return this.elearningService.getPrivateChat(this.courseDetail.COURSE_ID).pipe(
            map(c => {
              if (res.success) {

                form.controls['message'].setValue('');
                form.controls['messageType'].setValue('text');
                form.controls['userType'].setValue('user');
                form.controls['imageName'].setValue('');
                form.controls['file'].setValue('');
                this.fileList = [];
                this.privateChatImg = [];

                this.privateMessage = c.result;
                this.sendImageStatus = false;
                this.sendTextStatus = false;
                // this.incomingMessage = false;
                if (this.privateMessage[this.privateMessage.length - 1].USER_TYPE === 'admin') {
                  this.incomingMessage = true;
                } else {
                  this.incomingMessage = false;
                }

                setTimeout(() => {
                  this.scrollToBottom();
                  this.isLoading = false;
                }, 1000);
              }
            })
          )
        }

      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();

    // // console.log(this.privateChatImg);
    // // console.log(this.privateMessage);
  }

  downloadFile(fileUrl) {
    window.open(fileUrl, "_blank");
  }

  onTabChanged(e) {
    // // console.log(e);
    if (e.tab.textLabel === 'ข้อความส่วนตัว') {
      this.scrollToBottom();
      // // console.log(e.tab.textLabel);
    }
  }

  scrollToBottom(): void {
    try {
      this.chatroom.nativeElement.scrollTop = this.chatroom.nativeElement.scrollHeight;
    } catch (err) { }
  }


}
